const KEY = 'digiVolume'

export const loadVolume = () => {
  const savedStr = localStorage.getItem(KEY)
  if (savedStr === '0') {
    return 0
  }

  const savedVal = parseFloat(savedStr) || 1
  if (savedVal >= 0 && savedVal <= 1) {
    return savedVal
  }

  return 1
}

export const saveVolume = volume => {
  localStorage.setItem(KEY, volume)
}
